import { server_ip } from "../config";

export async function fetchEmailTemplates(token,filter, options) {
    try {
        const response = await fetch(`${server_ip}/api/emailTemplates/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function fetchEmailTemplateById(token, templateId) {
    try {
        const response = await fetch(`${server_ip}/api/emailTemplates/${templateId}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function adminInsertEmailTemplates(token, emailContents, title, name) {
    try {
        const response = await fetch(`${server_ip}/api/emailTemplates/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                emailContents,
                title,
                name
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function deleteEmailTemplateById(token, templateId) {
    try {
        const response = await fetch(`${server_ip}/api/emailTemplates/${templateId}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function updateEmailTemplateById(token, templateId, emailContents, title, name) {
    try {
        const response = await fetch(`${server_ip}/api/emailTemplates/${templateId}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                emailContents,
                title,
                name
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function sendEmailTemplate(token, templateId, receiverEmails=[], excludeEmails=[], isAllUsers=false) {
    try {
        let data = JSON.stringify({
                templateId,
                receiverEmails,
                excludeEmails,
                isAllUsers
            })
        const response = await fetch(`${server_ip}/api/emailTemplates/send`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: data
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}